import { render, staticRenderFns } from "./AnotherRubberPendant.vue?vue&type=template&id=6a749b9a&scoped=true&"
import script from "./AnotherRubberPendant.vue?vue&type=script&lang=js&"
export * from "./AnotherRubberPendant.vue?vue&type=script&lang=js&"
import style0 from "./AnotherRubberPendant.vue?vue&type=style&index=0&id=6a749b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a749b9a",
  null
  
)

component.options.__file = "AnotherRubberPendant.vue"
export default component.exports